<template>
	<div>
		<el-form ref="form" :model="so">
			<el-form-item label="筛选类型" style="display: flex; flex-wrap: nowrap; width: 100%;" label-width="80px">
				<el-input style="width: 24%;" v-model="so.dingdanhao">
					<template slot="prepend">订单号</template>
				</el-input>
				<el-input style="width: 24%;" v-model="so.kuaidihao">
					<template slot="prepend">快递单号</template>
				</el-input>
				<el-input style="width: 24%;" v-model="so.huiyuan">
					<template slot="prepend">用户信息</template>
				</el-input>
				<el-select v-model="so.zhifuqudao" placeholder="支付方式" clearable>
					<el-option label="支付宝" value="zhifubao"></el-option>
					<el-option label="微信支付" value="weixin"></el-option>
					<el-option label="微信小程序" value="xiaochengxu"></el-option>
					<el-option label="APP微信" value="appweixin"></el-option>
					<!-- <el-option label="积分兑换" value="duihuan"></el-option> -->
					<el-option label="余额支付" value="yu_e"></el-option>
					<el-option label="后台支付" value="houtai"></el-option>
					<el-option label="银联支付" value="yinlian"></el-option>
					<el-option label="货到付款" value="daofu"></el-option>
				</el-select>
			</el-form-item>
			<!-- <el-form-item label="派送点ID" label-width="80px">
				<Shanghu :id.sync="so.mendian" :ming.sync="so.mendianming" style="width: 80%;"></Shanghu>		
			</el-form-item>	 -->
			<el-form-item label="下单时间" label-width="80px">
				<!-- <el-date-picker v-model="so.shijian" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" /> -->
				<el-date-picker v-model="so.shijian" type="datetimerange"  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
				</el-date-picker>
			</el-form-item>
			<el-form-item style="padding: 0 70px;">
				<el-button type="info" size="small" style="margin-right: 10px;" @click="CSH">搜索</el-button>
				<el-button type="primary" size="small" style="margin-right: 10px;" @click="Danchu">导出Excel</el-button> 
				<el-button type="primary" size="small" @click="Yijianfahuo" v-if="so.zhuangtai==10">一键发货</el-button>
			</el-form-item>
		</el-form>
		<!-- 
		<el-form style="display: flex; flex-wrap: nowrap; width: 100%; margin-bottom: 0;">
			<el-form-item label="订单数:" style="width: 10%;">
				<span style="color: red;">{{zongshu}}</span>
			</el-form-item>
			<el-form-item label="订单金额:" style="width: 20%;">
				<span style="color: red;">{{zongjine}}</span>
			</el-form-item>
			<el-form-item label="买家:" label-width="123px"></el-form-item>
			<el-form-item label="支付方式:" label-width="155px"></el-form-item>
			<el-form-item label="价格:" label-width="113px"></el-form-item>
			<el-form-item label="状态:" label-width="163px"></el-form-item>

		</el-form> -->
		<ul style="display: flex; flex-wrap: nowrap; width: 100%; " class="biaotou">
			<li class="dindanlie1" style="width: 70%;display: flex;">
				<span style="font-size: 14px;color: #788188;">订单数</span><span style="color: red;margin:0 10px;">{{zongshu}}</span>
				<span style="font-size: 14px;color: #788188;">订单金额</span><span style="color: red;margin:0 10px;">{{zongjine}}</span>
			</li>
			<li style="width:24%;">买家</li>
			<li style="width:24%;">支付方式</li>
			<li style="width:24%;">价格:</li>
			<li style="width:22%;">状态:</li>
			<li style="width:11%;">操作:</li>
		</ul>
		<!-- 内容 -->
		<ul style="width: 100%;">
			<li v-for="l in lie">
				<el-tag type="info" style="width: 100%;height: 40px; line-height: 40px;" size="medium">订单编号：{{l.dingdanhao}}
					下单时间：{{l.xiadanshijian}}<i v-if="l.mendian && l.mendian.dianhua" class="tuanzhang">[团长：{{l.mendian.ming}} {{l.mendian.dianhua}}]</i></el-tag>
				<div class="nei">
					<div class="shangping">
						<div v-for="s in l.shangpin" style="" class="shangping_box">
							<el-image style="width: 50px; height: 50px" :src="s.tu" fit="cover"></el-image>
							<div class="f_right">
								<div style="margin-bottom: 10px; height: 25px; overflow: hidden;">{{s.ming}}</div>
								<div class="jiage_box">价格：{{s.jiage}} 数量：x{{s.shuliang}}</div>
							</div>
						</div>
					</div>
					<div class="shouhuo">
						<el-link :underline="false" type="primary">{{l.nicheng}}</el-link>
						<div>收货人：{{l.shouhuoren}}[{{l.shouhuodianhua}}]</div>
					</div>
					<div class="zhifu" style="width:8%;">
						<el-tag type="success" effect="dark" v-if="l.zhifuqudao">{{l.zhifuqudao_wenzi}}</el-tag>
					</div>
					<div class="jiage">
						<div>总计：￥{{l.shijia}}</div>
						<div>运费：￥{{l.yunfei}}</div>
						<div>折扣：￥-{{l.zhekou}}</div>
						<!-- <div>优惠券：￥-{{l.quan_e}}</div> -->
						<!-- <div>积分抵扣：￥-{{l.jifendikou}}</div> -->
						<div>应收：￥{{l.zongjia}}</div>
					</div>
					<div class="zhuantai" style="justify-content: center;display: flex;flex-wrap: wrap;">
						<el-tag size="small" type="danger" effect="dark" v-if="l.zhuangtai==10">{{l.zhuangtai_wenzi}}</el-tag>
						<el-tag size="small" type="success" effect="dark" v-else-if="l.zhuangtai==20">{{l.zhuangtai_wenzi}}</el-tag>
						<el-tag size="small" type="primary" effect="dark" v-else-if="l.zhuangtai==0">{{l.zhuangtai_wenzi}}</el-tag>
						<el-tag size="small" type="info" effect="dark" v-else>{{l.zhuangtai_wenzi}}</el-tag>
						<el-tag size="small" type="info" effect="dark" class="zhuantainiu" v-if="l.peisong==1">预定产品</el-tag>
						<el-tag size="small" type="info" effect="dark" class="zhuantainiu" v-else-if="l.peisong==3">门店配送</el-tag>
					</div>
					<div class="annius">
			<li class="btn" @click="Mianbandakai(['xiangqing',l])" style="background: #ffcc33;">查看详情</li>
			<ul v-if="l.zhuangtai==5 || l.zhuangtai==7"></ul>
			<ul v-else-if="l.zhuangtai==6" style="margin-top:-12p;position: absolute;top: 34px;">
				<li class="btn" @click="Caozuo('jujuetuikuan',l.id,'拒绝退款')" style="background: #ff6633; ">拒绝退款</li>
				<li class="btn" @click="Caozuo('tuikuan',l.id,'同意退款')" style="background:#ff0033">同意退款</li>
			</ul>
			<ul v-else-if="l.zhuangtai==10" style="margin-top:-12p;position: absolute;top:34px">
				<li class="btn" @click="Caozuo('tuikuan',l,'给他退款')" style="background:#ff6633">给他退款</li>
				<li class="btn" @click="Dayindingdan(l)" style="background:#ff0033">打印订单</li>
				<li class="btn" @click="Caozuo('tihuo',l.dingdanhao,'确认提货')" style="background:#b9072a">确认提货</li>
			</ul>
			<ul v-else-if="l.zhuangtai==15" style="margin-top:-12p;position: absolute;top:34px">
				<li class="btn" @click="Caozuo('shouhuo',l,'拒绝退货')" style="background:#ff6633;">拒绝退货</li>		
				<li class="btn" @click="Caozuo('tuikuan',l,'给他退款')" style="background:#ff0033;">给他退款</li>
				<li class="btn" @click="Mianbandakai(['fahuo',l])" style="background:#b9072a">确认发货</li>
			</ul>
			<ul v-else-if="l.zhuangtai==20" style="margin-top:-12p;position: absolute;top:34px">
				<!-- <li class="btn" @click="Mianbandakai(['kuaidi',l])" style="background: #ff6633;">快递物流</li> -->
				<li class="btn" @click="Caozuo('tihuo',l.dingdanhao,'确认提货')" style="background:#ff0033;">确认提货</li>
			</ul>
			<ul v-else-if="l.zhuangtai==30" style="margin-top;position: absolute;top:34px">
				<!-- <li class="btn" @click="Mianbandakai(['kuaidi',l])" style="background:#ff6633">快递物流</li> -->
				<li class="btn" @click="Dayindingdan(l)" style="background:#ff0033">打印订单</li>
			</ul>
			<ul v-else style="margin-top:-12p;position: absolute;top:34px">
				<li class="btn" @click="Caozuo('quxiao',l.dingdanhao,'关闭订单')" style="background:#ff6633">关闭订单</li>
				<li class="btn" @click="Caozuo('fukuan',l.dingdanhao,'确定付款')" style="background:#ff0033">确认付款</li>
			</ul>
	</div>
	</div>
	</li>
	</ul>
	<el-pagination background layout="total,prev,pager,next,jumper" :total="zongshu" :page-size="so.jitiao"
	 :current-page.sync="so.ye" @current-change="CSH" style="margin-top: 30px;" />

	<el-dialog title="发货" :visible.sync="mianban.fahuo">
		<el-form>
			<el-form-item label-width="100px">
				<el-avatar shape="square" :src="mianban_shu.touxiang"></el-avatar>
				<span>{{mianban_shu.shouhuoren}}[{{mianban_shu.shouhuodianhua}}]</span>
			</el-form-item>
			<el-form-item label="收货地址" label-width="100px">
				<span>{{mianban_shu.shouhuoshengshiqu}} {{mianban_shu.shouhuodizhi}}</span>

			</el-form-item>
			<el-form-item label="快递公司" label-width="100px">
				<el-select v-model="mianban_shu.kuaidiid" placeholder="快递公司">
					<el-option :label="l.ming" :value="l.id" v-for="l in kuaidilie"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="快递单号" label-width="100px">
				<el-input v-model="mianban_shu.kuaidihao" style="width: 50%;"></el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="mianban.fahuo = false">取 消</el-button>
			<el-button type="primary" @click="Mianban_tijiao('fahuo')">确 定</el-button>
		</div>
	</el-dialog>
	<!-- 订单详情弹框 -->
	<el-drawer title="订单详情" :visible.sync="mianban.xiangqing" direction="ttb" size="90%">
		<div class="demo-drawer__content" style="overflow-y: scroll; height: 96vh; padding-bottom: 240px;">
			<el-form class="dingdan" style="margin-top: 30px;margin-bottom: 40px;">
				<el-form-item label="" label-width="180px" style="position: relative;">
					<el-image :src="mianban_shu.touxiang" style="width: 50px; height: 50px;"></el-image>
					<el-link :underline="false" style="position: absolute;top: -8px; left: 6%;">昵称:<span style="margin-left: 10px;">{{mianban_shu.nicheng}}</span></el-link>
					<el-link :underline="false" style="position: absolute;top: 20px; left:6%;">账号:<span style="margin-left: 10px;">{{mianban_shu.zhanghao}}</span></el-link>
					<div style="width: 1px; height: 50px; background: #606266;position: absolute;top: 0px; left: 32%;"></div>
					<div :underline="false" style="position: absolute;top: -12px; left: 34%;" class="shouhuoren">
						收货人:<el-input size="small" style="margin-left:10px;width:70%" v-model="mianban_shu.shouhuoren"></el-input>
					</div>
					<div :underline="false" style="position: absolute;top: 24px; left: 34%;">
						地址:<el-input size="small" style="margin-left:30px;width:70%" v-model="mianban_shu.shouhuodizhi"></el-input>
					</div>
					<div class="anniu">
						<el-button type="warning" size="small">{{mianban_shu.zhuangtai_wenzi}}</el-button>
						<el-button type="danger" size="small">打印</el-button>
					</div>
				</el-form-item>

				<el-table :data="[mianban_shu]" style="width: 100%" border>
					<el-table-column prop="dingdanhao" label="订单信息"></el-table-column>
					<el-table-column prop="xiadanshijian" label="下单时间"></el-table-column>
					<el-table-column prop="zhifushijian" label="付款时间"></el-table-column>
					<el-table-column prop="fahuoshijian" label="发货时间"></el-table-column>
					<el-table-column prop="wanchengshijian" label="完成时间"></el-table-column>
				</el-table>
				<el-table :data="[mianban_shu]" style="width: 100%" border>
					<el-table-column prop="zhifuqudao_wenzi" label="支付方式"></el-table-column>
					<el-table-column prop="kuaidihao" label="快递号"></el-table-column>
					<el-table-column prop="kuaidiid" label="快递公司"></el-table-column>
					<el-table-column label="配送方式">
						<template slot-scope="shu">
							<span v-if="shu.row.peisong==1">预定产品</span>
							<span v-else>快递物流</span>
						</template>
					</el-table-column>
					<el-table-column label="核销员"></el-table-column>
				</el-table>
			</el-form>
			<el-table :data="mianban_shu.shangpin" style="width:1103px;margin: 0 auto;" show-summary>
				<el-table-column prop="xinxi" label="商品信息" width="300">
					<template slot-scope="shu">
						<el-avatar shape="square" :size="40" fit="cover" :src="shu.row.tu"></el-avatar>
						<span style="position: absolute;left: 60px; top: 12px;">{{shu.row.ming}}</span>
						<span style="position: absolute;left:60px; top: 30px;color: #abaaaa;">{{shu.row.guigeming}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="jiage" label="单价" width="80" />
				<el-table-column prop="shuliang" label="数量" width="80" />
				<el-table-column prop="yunfei" label="运费" width="80" />
				<el-table-column label="小合计" width="80">
					<template slot-scope="shu">
						{{(shu.row.jiage*shu.row.shuliang*shu.row.yunfei).toFixed(2)}}
					</template>
				</el-table-column>
				<el-table-column prop="zhekou" label="折扣" width="80" />
				<el-table-column prop="jifendikou" label="积分抵扣" width="80" />
				<el-table-column prop="quan_e" label="优惠券" width="80" />
				<el-table-column prop="zongjia" label="总合计" />
				<el-table-column label="操作" width="80">
					<template slot-scope="shu">
						<span>退货</span>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</el-drawer>
	<!-- 物流详情弹框 -->
	<el-dialog title="快递查询" :visible.sync="mianban.kuaidi" direction="ttb" size="90% ">
		<div class="demo-drawer__content" style="overflow-y: scroll; height: 40vh; padding-bottom: 240px;padding: 0 40px;">
			<el-timeline v-if="mianban_shu && mianban.kuaidi">
				<el-timeline-item v-for="(l,i) in mianban_shu" :key="i"  :timestamp="l.shijian">{{l.weizhi}}</el-timeline-item>
			</el-timeline>
		</div>
	</el-dialog>
	</div>
</template>

<script>
	let that;
	import Shanghu from './Shanghu.vue'
	export default {
		data() {
			return {
				so: {
					ye: 1,
					jitiao: 10,
					zhuangtai: 10
				},
				lie: [],
				zongshu: 0,
				zongjine: 0,
				mianban: {
					fahuo: false,
					xiangqing: false,
					kuaidi: false,
					tihuo:false
				},
				mianban_shu: [],
				kuaidilie: [{
						id: 'SF',
						ming: '顺丰速运'
					},
					{
						id: 'HTKY',
						ming: '百世快递'
					},
					{
						id: 'ZTO',
						ming: '中通快递'
					},
					{
						id: 'STO',
						ming: '申通快递'
					},
					{
						id: 'YTO',
						ming: '圆通速递'
					},
					{
						id: 'YD',
						ming: '韵达速递'
					},
					{
						id: 'YZPY',
						ming: '邮政快递包裹'
					},
					{
						id: 'EMS',
						ming: 'EMS'
					},
					{
						id: 'HHTT',
						ming: '天天快递'
					},
					{
						id: 'JD',
						ming: '京东快递'
					},
					{
						id: 'UC',
						ming: '优速快递'
					},
					{
						id: 'DBL',
						ming: '德邦快递'
					},
					{
						id: 'ZJS',
						ming: '宅急送'
					},
					{
						id: 'TNT',
						ming: 'TNT快递'
					},
					{
						id: 'UPS',
						ming: 'UPS'
					},
					{
						id: 'DHL',
						ming: 'DHL'
					},
					{
						id: 'FEDEX',
						ming: 'FEDEX联邦(国内件）'
					},
					{
						id: 'FEDEX_GJ',
						ming: 'FEDEX联邦(国际件'
					},
					{
						id: 'wuxukuaidi',
						ming: '无需快递'
					}
				],			
			}
		},
		props: {
			m:{
			  type:String,
			  default:"zw_shangcheng"
			},
		},
		components: {Shanghu},
		mounted() {
			that = this;
			that.CSH();
		},
		methods: {
			CSH() {
				that.so.peisong=1
				this.$post('m='+this.m+'&k=dingdan', that.so, function(s) {
					that.lie = s.shu.lie;
					that.zongshu = Number(s.shu.zongshu);
					that.zongjine = Number(s.shu.zongjine);
				});
			},
			Mianbandakai(e) {
				that.mianban[e[0]] = true;
				that.mianban_shu=[];
				if(e[0]=='kuaidi'){
					this.$post('k=kuaidi&c=Chakuaidi', {						
						kuaidihao:e[1].kuaidihao,
						kuaidiid:e[1].kuaidiid
					}, function(s) {						
						if (s.shu) {							
							that.mianban_shu= s.shu;
						}
					});
				}else{
					that.mianban_shu = e[1];						
				}
				
				
			},
			Mianban_tijiao(e) {
				if (e == "fahuo") {
					this.$post('m='+this.m+'&k=dingdan&c=Fahuo', {
						id: that.mianban_shu.id,
						kuaidihao: that.mianban_shu.kuaidihao,
						kuaidiid: that.mianban_shu.kuaidiid
					}, function(s) {
						that.$xiaoxi(s.shu);
						if (s.shi == 1) {
							that.CSH();
							that.mianban[e] = false;
						}
					});
				}
			},
			Caozuo(a, b, c) {
				if(a=='tihuo'){
					this.$confirm(c, '确认提货', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.$post("k=hexiaomingxi&c=Dingdanhexiao",{id:b}, (s)=> {
							that.$xiaoxi(s.shu);
						})
					});
					
				}else{
					this.$confirm(c, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.$post('m='+this.m+'&k=dingdan', {
							id: b,
							c: a
						}, function(s) {
							that.$xiaoxi(s.shu);
							if (s.shi == 1) {
								that.CSH();
							}
						});
					});
				}

			},
			Dayindingdan(e){
				that.$post('m='+this.m+'&k=dingdan', {
					shu: e,
					c: 'dayin'
				}, function(s) {
					// that.$xiaoxi(s.shu);					
				});
			},
			Yijianfahuo(){			
				this.$confirm('一键发货，只支持时间筛选', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$post('m='+this.m+'&k=dingdan&c=yijianfahuo', that.so, function(s) {
						that.$xiaoxi(s.shu);			
						if(s.shi==1){
							that.CSH()
						}
					});
				});
			},
			Danchu(){				
				this.$post('m='+this.m+'&k=dingdan&c=Daochu', that.so, function(s) {
					if(s.shi==1){
						window.open(that.$url+'&k=denglu&c=daochu&wenjianming='+s.shu);  
					}else{
						that.$xiaoxi(s.shu);			
					}
				});
			}
			

		}
	}
</script>

<style>


</style>
